import { IMemDB } from "@/db/IMemDB";
import db from "@/db";
import { IDB } from "@/db/idb";
export class MobiDocument {
    public get memdb() {
        return this.getMemDb();
    }
    public set memdb(v: any) {

    }
    public getDb(): IDB {
        return db;
    }
    public setMemDb(value: any): MobiDocument {
        return this;
    }
    public getMemDb(): IMemDB {
        return db.memDB
    }
    public find(filter: any): Array<any> {
        return db.memDB.find(filter);
    }
}